import { BidModalStates } from './index';

export const stateToContent = (
  state: BidModalStates,
): 'loading' | 'credit-card' | 'confirm' | 'error' => {
  switch (state) {
    case 'cc-waiting-user':
    case 'cc-submitting':
    case 'cc-success':
      return 'credit-card';
    case 'confirm-waiting-user':
    case 'confirm-submitting-bid':
    case 'confirm-success':
      return 'confirm';
    case 'error':
    case 'loading':
      return state;
  }
};
